export const LAYER_NAME = {
  CIRCLES_LITTLE: 'circles-layer-little',
  CIRCLES_MEDIUM: 'circles-layer-medium',
  CIRCLES_LARGE: 'circles-layer-large',
  TEXT_LITTLE: 'text-layer-cluster-little',
  TEXT_MEDIUM: 'text-layer-cluster-medium',
  TEXT_LARGE: 'text-layer-cluster-large',
  ICON_LITTLE: 'text-layer-cluster-little-icons',
  CLUSTER_MEDIUM: 'text-layer-cluster-medium-icons',
  CLUSTER_LARGE: 'text-layer-cluster-large-icons',
  CLUSTER: 'selected-cluster-layer'
} as const

export const LAYER_OPACITY = {
  LITTLE: 0.03,
  MEDIUM: 0.1,
  LARGE: 0.24
}

export const LAYER_CIRCLE_COLOR: Record<
  'PRIMARY' | 'SELECTED',
  [number, number, number]
> = {
  PRIMARY: [255, 102, 0],
  SELECTED: [50, 50, 50]
}

export const LAYER_CIRCLE_STROKE: Record<
  'PRIMARY' | 'SELECTED',
  [number, number, number]
> = {
  PRIMARY: [0, 0, 0],
  SELECTED: [20, 20, 20]
}

export const LAYER_TEXT_COLOR: Record<
  'PRIMARY' | 'SELECTED',
  [number, number, number, number]
> = {
  PRIMARY: [8, 35, 35, 100],
  SELECTED: [8, 35, 35, 100]
}
